import standardAPI from '@/api/standard_items';

const responseUrl = '/organisation-tours/tour_directions';

const state = {
  tour_directions: [],
  tour_directions_MetaData: {},
  tour_directions_status: '',
  tour_directions_page: 1,
  tour_directions_perPage: 10,
};

const getters = {
  get_tour_directions: (state) => {
    return state.tour_directions;
  },
  get_tour_directions_status: (state) => {
    return state.tour_directions_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_tour_directions ({ commit }, getOptions) {
    commit('DATA_TOUR_DIRECTIONS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_TOUR_DIRECTIONS_UPDATE_SUCCESS', response);
            commit('DATA_TOUR_DIRECTIONS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_TOUR_DIRECTIONS_READY');
            reject(response);
          } else {
            commit('DATA_TOUR_DIRECTIONS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_tour_directions_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_tour_direction ({ commit, dispatch }, itemData) {
    commit('DATA_TOUR_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_TOUR_DIRECTIONS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_TOUR_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  edit_tour_direction ({ commit, dispatch }, itemData) {
    commit('DATA_TOUR_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_TOUR_DIRECTIONS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_TOUR_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  remove_tour_directions ({ commit, dispatch }, itemData) {
    commit('DATA_TOUR_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_TOUR_DIRECTIONS_REQUEST');
          resolve();
        } else {
          commit('DATA_TOUR_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_tour_direction ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_tour_direction_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.tour_directions_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.tour_directions_perPage = max;
  },
  DATA_TOUR_DIRECTIONS_READY: (state) => {
    state.tour_directions_status = 'ready';
  },
  DATA_TOUR_DIRECTIONS_REQUEST: (state) => {
    state.tour_directions_status = 'loading';
  },
  DATA_TOUR_DIRECTIONS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.tour_directions_MetaData.meta = response.meta;
      state.tour_directions_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.tour_directions = response.data || [];
    }
    state.tour_directions_status = 'success';
  },
  DATA_TOUR_DIRECTIONS_ERROR: (state) => {
    state.tour_directions_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
